import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ThemeToggle from "../ThemeToggle";
import { HashLink } from 'react-router-hash-link';
import { useContext } from "react";
import { ThemeContext } from "../../ThemeContext";
import { Link } from "react-router-dom";

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { theme, toggleTheme } = useContext(ThemeContext);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    if (!location.hash) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location]);

  const links = [
    { name: "Home", href: "/", isRouterLink: true },
    { name: "Projects", href: "/projects", isRouterLink: true },
    { name: "Skills", href: "/skills", isRouterLink: true },
    { name: "Contact", href: "/#contact", isRouterLink: true },
  ];

  // For mobile: show only first 2 links, rest in menu
  const mobileQuickLinks = links.slice(0, 2);
  const mobileMenuLinks = links.slice(2);

  return (
    <div className="fixed bg-white dark:bg-[#121212] z-50 top-0 left-0 right-0 flex justify-between items-center w-full p-8 mt-0 md:mb-10 mx-auto">
      <div className="flex flex-row justify-between items-center w-full max-w-5xl mx-auto">
        <ThemeToggle theme={theme} toggleTheme={toggleTheme} />

        {/* Mobile Quick Links */}
        <div className="sm:hidden flex items-center space-x-4">
          {mobileQuickLinks.map((link) =>
            link.isRouterLink ? (
              link.name === "Contact" ? (
                <HashLink
                  key={link.name}
                  to={link.href}
                  className="text-md font-medium text-gray-800 dark:text-gray-200"
                  smooth
                >
                  {link.name}
                </HashLink>
              ) : (
                <Link
                  key={link.name}
                  to={link.href}
                  className="text-md font-medium text-gray-800 dark:text-gray-200"
                >
                  {link.name}
                </Link>
              )
            ) : (
              <a
                key={link.name}
                href={link.href}
                className="text-md font-medium text-gray-800 dark:text-gray-200"
              >
                {link.name}
              </a>
            )
          )}
          <button
            className="text-gray-800 dark:text-gray-200"
            onClick={toggleMenu}
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {isMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>

        {/* Desktop Menu */}
        <div className="hidden sm:flex space-x-8 rounded-full bg-white/90 px-6 py-2 text-lg font-medium text-zinc-800 shadow-lg shadow-zinc-800/5 ring-1 ring-zinc-900/5 backdrop-blur dark:bg-zinc-900/90 dark:text-zinc-200 dark:ring-white/10">
          {links.map((link) =>
            link.isRouterLink ? (
              link.name === "Contact" ? (
                <HashLink
                  key={link.name}
                  to={link.href}
                  className="text-lg font-medium text-gray-800 dark:text-gray-200"
                  smooth
                >
                  {link.name}
                </HashLink>
              ) : (
                <Link
                  key={link.name}
                  to={link.href}
                  className="text-lg font-medium text-gray-800 dark:text-gray-200"
                >
                  {link.name}
                </Link>
              )
            ) : (
              <a
                key={link.name}
                href={link.href}
                className="text-lg font-medium text-gray-800 dark:text-gray-200"
              >
                {link.name}
              </a>
            )
          )}
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="absolute top-[76px] left-0 right-0 bg-white dark:bg-[#121212] px-4 py-2 sm:hidden shadow-lg ">
            <div className="flex flex-col space-y-3">
              {mobileMenuLinks.map((link) =>
                link.isRouterLink ? (
                  link.name === "Contact" ? (
                    <HashLink
                      key={link.name}
                      to={link.href}
                      className="text-md font-medium ml-64 text-gray-800 dark:text-gray-200 hover:text-indigo-600 dark:hover:text-indigo-400"
                      onClick={toggleMenu}
                      smooth
                    >
                      {link.name}
                    </HashLink>
                  ) : (
                    <Link
                      key={link.name}
                      to={link.href}
                      className="text-md font-medium ml-64 text-gray-800 dark:text-gray-200 hover:text-indigo-600 dark:hover:text-indigo-400"
                      onClick={toggleMenu}
                    >
                      {link.name}
                    </Link>
                  )
                ) : (
                  <a
                    key={link.name}
                    href={link.href}
                    className="text-md font-medium ml-64 text-gray-800 dark:text-gray-200 hover:text-indigo-600 dark:hover:text-indigo-400"
                    onClick={toggleMenu}
                  >
                    {link.name}
                  </a>
                )
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Navbar;
